module.exports = __webpack_public_path__ + "media/images/regional-image16-92878df435d22de30a534724d9c66511.jpg";